export default __webpack_public_path__ + "static/media/amberfort.3d4c83fc.jpg";